// features/counter/counterSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ITeamStateObject{
  id: number| undefined,
  teamName: string | undefined,
  backgroundImage: string | undefined,
  categoryId: number | undefined
}

// Define a type for the slice state
interface TeamState {
  team: ITeamStateObject | null;
}

// Define the initial state using that type
const initialState: TeamState = {
    team: {id : -1, teamName: '', backgroundImage: '', categoryId: -1},
};

const teamSlice = createSlice({
  name: 'team',
  initialState,
  reducers: {
    setTeam: (state, action: PayloadAction<ITeamStateObject>) => {
      state.team = action.payload;
      console.log("TeamRedux", action.payload);
    }
  }
});

export const { setTeam } = teamSlice.actions;

export default teamSlice.reducer;
